var map = {
	"./01_seimeihoken.png": "tqm2",
	"./02_hoken.png": "S9sH",
	"./03_keiyaku.png": "zjVS",
	"./04_website.png": "8lGX",
	"./05_lifenetseimei.png": "BeTv",
	"./06_coronavirus.png": "y2O1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vLi/";